import { render } from "./DeltaPill.vue?vue&type=template&id=2e2d4b84&scoped=true&ts=true"
import script from "./DeltaPill.vue?vue&type=script&lang=ts"
export * from "./DeltaPill.vue?vue&type=script&lang=ts"

import "./DeltaPill.vue?vue&type=style&index=0&id=2e2d4b84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2d4b84"]])

export default __exports__